import React, { FC } from 'react';
import { Modal } from '@clearcover/atlas';
import { ConfirmationModal } from 'Shared/components';

interface RollbackConfirmationModalProps {
  open: boolean;
  versionNumber: number;
  onClose: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  error?: string;
}

export const RollbackConfirmationModal: FC<RollbackConfirmationModalProps> = ({
  open,
  versionNumber,
  onClose,
  onSubmit,
  isSubmitting,
  error,
}) => {
  return (
    <Modal controlled={true} open={open} handleClose={onClose}>
      {(_close) => (
        <ConfirmationModal
          onSubmit={onSubmit}
          close={onClose}
          isSubmitting={isSubmitting}
          error={error}
          headerText={`Rollback to Version ${versionNumber}?`}
          bodyText="This will create a new draft reverting to this version. The draft will be ready for review."
          confirmText="Rollback"
          variant="danger"
        />
      )}
    </Modal>
  );
};
